<script>
export default {
    props: {
        listData: {type: Array, required: true},
        size: {type: Number, required: false, default: 10}
    },
    data: () => ({pageNumber: 0}),
    computed: {
        pageCount() {
            return Math.ceil(this.listData.length / this.size);
        },
        paginatedData() {
            const start = this.pageNumber * this.size,
                  end = start + this.size;
            return this.listData.slice(start, end);
        }
    },
    methods: {
        nextPage() { this.pageNumber++; },
        previousPage() { this.pageNumber--; },
        getPage(page) { this.pageNumber = page - 1; }
    }
};
</script>
